module.exports = __webpack_public_path__ + "ford.d50de5c480edff1e8f69.png";